
<textarea rows="4"
          [formControl]="textareaControl"
          [disabled]="disabled"
          [placeholder]="placeholderText"
          (input)="onInput()"
          [ngClass]="isHighlighted ? 'highlight-red'  : ''">
</textarea>
<div class="count-div">
  <p>{{ numberOfCharacters }} / {{ maxNumberOfCharacters }}</p>
</div>
